
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'FeedbackReceipt',
  props: {
    success: {
      type: Boolean,
      required: true,
    },
    error: {
      type: Boolean,
      required: true,
    },
  },
})
